import { makeStyles } from '@material-ui/styles';
import { primaryFontFamily, primaryTextColor } from '../../../constants/StyleConfig';
import { mediumGray } from '../../../constants/Colors';

export default makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    },
    selectedValue: {
        padding: '4px 0',
    },
    activeArea: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        padding: '4px 5px',
    },
    arrowDropDown: {
        color: primaryTextColor,
        transition: 'transform linear 150ms',
        transform: ({ isOpen }) => (isOpen ? 'rotateX(180deg)' : 'none'),
        marginRight: 10,
    },
    option: {
        fontSize: 15,
        fontFamily: primaryFontFamily,
        color: primaryTextColor,
        '&:hover': {
            fontWeight: 600,
        },
    },
    optionDisabled: {
        color: `${mediumGray} !important`,
        cursor: 'auto',
        '&:hover': {
            cursor: 'auto',
            fontWeight: 'normal',
            backgroundColor: 'transparent !important',
        },
    },
    paper: {
        zIndex: 5,
        overflow: 'auto',
        right: ({ isLeftAligned }) => (isLeftAligned ? '' : 0),
        left: ({ isLeftAligned }) => (isLeftAligned ? 0 : ''),
        maxHeight: ({ maxListHeight }) => (maxListHeight || ''),
    },
}));
